import {
    ResultObj,
    allFetch,
} from "../Domain";
/**
 * @description 前台呼叫列出帳號&系統功能綁定關係(回傳)
 * @param {string} key 
 * @param {string} value 
 */
export interface PermissionCheckValidResItem {
    key: string;
    value: 'Y' | 'N';
}

/**
 * @description 前台呼叫列出帳號&系統功能綁定關係
 */
export const PermissionCheckValid = async function (): Promise<ResultObj<PermissionCheckValidResItem[]>> {
    return await allFetch('PermissionFunction/PermissionCheckValid', {});
};